import service from '@/services'

// state
const state = {
}

// getters
const getters = {
}

// actions
const actions = {
  getNotice: ({commit}, payload) => {
    return service.getNotice(commit, payload)
  },
  updateNotice: ({commit}, payload) => {
    return service.updateNotice(commit, payload)
  }
}

// mutations
const mutations = {
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/message.js